define('home/collections/PostCollection',[
    'core/collections/PaginatedCollection',
    'core/UniqueModel',
    'home/models/Post',
], function (
    PaginatedCollection,
    UniqueModel,
    Post
) {
    'use strict';

    return PaginatedCollection.extend({
        model: UniqueModel.boundModel(Post),
    });
});

